module.exports = __webpack_public_path__ + "img/icon-basic-default.19193dd4.svg";